export enum EventRestrictionType {
  DEFAULT = 'DEFAULT',
  COVID = 'COVID',
  BAGS = 'BAGS',
  SOCIAL = 'SOCIAL',
  MERCHANDISE = 'MERCHANDISE',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/event-restriction-type.ts